import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js'
import { memo } from 'react'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

//
//

const getXAxisTickCallback = (xAxisFormat) => (value) => {
  if (xAxisFormat === 'percentages') {
    const pct = (parseFloat(value) * 100).toFixed(1).replace('.', ',')

    return `${pct} %`
  }

  return value
}

//
//

const FCHorizontalBarChart = ({ data, xAxisFormat }) => {
  const options = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
      legend: { display: false },
      datalabels: {
        color: '#fff',
        font: { size: 12, weight: 'bold' },
        formatter: getXAxisTickCallback(xAxisFormat),
      },
    },
    scales: {
      x: {
        ticks: {
          callback: getXAxisTickCallback(xAxisFormat),
          font: { size: 11 },
          maxTicksLimit: 8,
        },
        grid: { color: 'rgba(0,0,0,0.06)' },
      },
      y: {
        ticks: { font: { size: 12 } },
        grid: { display: false },
      },
    },
  }

  return <Bar data={data} options={options} />
}

export const HorizontalBarChart = memo(FCHorizontalBarChart)
